import API from "./axios";

export class sendFileToServer {
    uploadfile(filename : string, filedata : string): Promise<any> {
        return API.post(`api/uploadfile.php`, { action: 'uploadFile', src: 'dashboard', retrievalmode: 'mysql' });
    }
  
  ///  batchUpload( data: any):async (params:type) => {
        
   // } () => {
      
       // const response =await  API.post(`api/index.php`, { 'action': 'uploadFile', 'src': 'dashboard', retrievalmode: 'mysql', 'data': [data] });
   // }

     //async
      batchImageUpload (data: any  ): Promise<any>  {
          return  API.post(`api/index.php`, { 'action': 'uploadFile', 'src': 'dashboard' ,  retrievalmode: 'mysql', 'data': [data] });
      };


      // async 
      processBatchData (data: any): Promise<any>  {
        return  API.post(`api/index.php`, { 'action': 'processBatch', 'src': 'dashboard', retrievalmode: 'mysql', 'data': [data] });
    };



    getProductListMasterSchema(): Promise<any> {

        return API.post(`api/index.php`, { action: 'getDBSchema', src: 'dashboard', retrievalmode: 'mysql' });
        
        //return API.post(`api/index.php`, { action: 'getProductListMasterSchema', src: 'dashboard', retrievalmode: 'mysql' });
    }
    

}